import { requiredOptionMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

export const provinceValidator = trimmedString;
export const provinceValidatorRequired = trimmedString.required(
  requiredOptionMessage
);
